import Cookies from 'universal-cookie';
import AuthResponse from '@/apiModels/AuthResponse';
class AuthCookieHandler {
  cookie: Cookies;

  constructor() {
    this.cookie = new Cookies();
  }

  saveAuth = (data: AuthResponse) => {
    this.cookie.set('auth', JSON.stringify(data), {
      path: '/',
      maxAge: 60 * 60 * 24 * 14, // 14 days
      secure: true,
      httpOnly: false,
      sameSite: 'none',
    });
  };

  getAuth = (): AuthResponse | null => {
    const raw = this.cookie.get('auth');
    if (!raw) return null;

    try {
      return typeof raw === 'string' ? JSON.parse(raw) : raw;
    } catch {
      return null;
    }
  };

  getRefreshToken = (): string | null => {
    const auth = this.getAuth();
    if (!auth) return null;
    return auth.refresh_token;
  };

  isAuthenticated = (): boolean => {
    const auth = this.getAuth();
    return !!auth && !!auth.access_token;
  };

  getAccessToken = (): string => {
    const auth = this.getAuth();
    if (!auth) throw new Error('No auth available');
    return auth.access_token;
  };
  removeAuth = () => this.cookie.remove('auth', { path: '/' });
}

export default AuthCookieHandler;
